import { ProductMembersListToolbarState } from "@/product/member/page/useProductMembersListToolbarState"
import DiscoTableFilterTags from "@disco-ui/table/header/filter/DiscoTableFilterTags"
import DiscoTag from "@disco-ui/tag/DiscoTag"

interface Props {
  toolbarState: ProductMembersListToolbarState
  setToolbarState: React.Dispatch<React.SetStateAction<ProductMembersListToolbarState>>
}

function ProductMembersListPageFilterTags({ toolbarState, setToolbarState }: Props) {
  const { profileFields, selectedRole, selectedGroup } = toolbarState

  const profileFieldFilters = profileFields
    ? Object.values(profileFields).filter((value) => Boolean(value))
    : []

  const roleIsSelected = Boolean(selectedRole)
  const groupIsSelected = selectedGroup.value !== "all"
  const profileFieldIsSelected = profileFieldFilters.length > 0

  const showFilterTags = roleIsSelected || groupIsSelected || profileFieldIsSelected

  return (
    <DiscoTableFilterTags isVisible={showFilterTags}>
      {roleIsSelected && (
        <DiscoTag
          testid={"ProductMembersListPage.filter-tag.role"}
          name={selectedRole!.title}
          onDelete={() => {
            setToolbarState({
              ...toolbarState,
              selectedRole: null,
            })
          }}
        />
      )}
      {groupIsSelected && (
        <DiscoTag
          testid={"ProductMembersListPage.filter-tag.group"}
          name={selectedGroup.title}
          onDelete={() => {
            setToolbarState({
              ...toolbarState,
              selectedGroup: {
                value: "all",
                title: "All Groups",
              },
            })
          }}
        />
      )}
      {profileFieldFilters.map((filter) => (
        <DiscoTag
          key={filter!.fieldTitle}
          name={`${filter!.fieldTitle}: ${filter!.title}`}
          testid={`ProductMembersListPage.filter-tag.profile-field.${filter!.fieldTitle}`}
          onDelete={() => {
            setToolbarState({
              ...toolbarState,
              profileFields: {
                ...toolbarState.profileFields,
                [filter!.fieldId]: null,
              },
            })
          }}
        />
      ))}
    </DiscoTableFilterTags>
  )
}

export default ProductMembersListPageFilterTags
